import PopupService from 'src/utils/PopupService';
import i18n from 'src/lang/i18n';
import dayjs from 'dayjs';
import { DayValue } from 'react-modern-calendar-datepicker';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { REPLACE_IDENTIFIER } from 'src/constants';
import { History } from 'history';
import UserInfoService from 'src/utils/UserInfoService';
import { gaTrackEvent, wakandaLogActionApi } from 'src/api';
import moment from 'moment';
dayjs.extend(customParseFormat);

export const sendOpenNewWebview = (item) => {
  if (window?.ReactNativeWebView?.postMessage) {
    window?.ReactNativeWebView?.postMessage(
      JSON.stringify({
        type: 'OPEN_NEW_WEBVIEW',
        source: 'web_mobile',
        name: item.name,
        link: item.link,
      })
    );
  }
};

export const goBack = () => {
  if (window?.ReactNativeWebView) {
    window?.ReactNativeWebView?.postMessage(
      JSON.stringify({
        type: 'go_back',
        source: 'web_mobile',
      })
    );
  }
};

export const goBackCustom = (history) => {
  history.goBack();
};

export const handleGoBack = (history: History) => {
  const canGoBack = history?.action !== 'POP';
  if (canGoBack) {
    history?.goBack();
  } else goBack();
};

export const sendOpenPdf = (item) => {
  if (window?.ReactNativeWebView?.postMessage) {
    window?.ReactNativeWebView?.postMessage(
      JSON.stringify({
        type: 'OPEN_PDF',
        source: 'web_mobile',
        name: item.name,
        link: item.link,
      })
    );
  }
};

export const removeAccent = (str: string): string => {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
  str = str.replace(/đ/g, 'd');
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
  str = str.replace(/Đ/g, 'D');
  return str;
};

export const isValidDate = (dateStr: string, format: string): boolean => {
  return dayjs(dateStr, format).format(format) === dateStr;
};

export const convertDateToDayValue = (date: Date): DayValue => {
  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
  };
};

export const convertDayValueToDate = (dayValue: DayValue): Date => {
  return new Date(dayValue.year, dayValue.month - 1, dayValue.day);
};

export const confirmQuitFlow = (
  history,
  content = i18n.t('confirm_quit_cancer')
) => {
  PopupService.instance.current.open({
    visible: true,
    title: i18n.t('notification'),
    content,
    okTitle: i18n.t('stay'),
    cancelTitle: i18n.t('exit'),
    onOk: () => {
      PopupService.instance.current.close();
    },
    onCancel: () => {
      PopupService.instance.current.close();
      goBack();
    },
  });
};

export const formatMoney = (str) => {
  if (!isNaN(str)) {
    str = Math.floor(str);
  }
  if (str == null || typeof str == 'undefined' || str.length === 0) return '';
  str = (+str).toString();
  if (str.length == 2 && str[1] == 0 && str[0] == 0) {
    return '0';
  }

  let number = Number(str);
  return number.toLocaleString('en-Us');
};

// export const formatMoney = (str) => {
//   if (!isNaN(str)) {
//     str = Math.floor(str);
//   }
//   str = (+str).toString();
//   if (str == null || typeof str == 'undefined' || str.length === 0) return '';

//   if (str.length == 2 && str[1] == 0 && str[0] == 0) {
//     return '0';
//   }

//   var temp = str;

//   for (let i = 0; i < temp.length; i++) {
//     if (temp[i] != '0') {
//       temp = temp.substr(i);
//       if (temp.length > 1 && temp[0] == '.') {
//         temp = temp.substr(1);
//       }
//       if (temp < 0) {
//         return (
//           '-' +
//           temp
//             .toString()
//             .replace(/\D/g, '')
//             .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
//         );
//         // console.log("temp ==", temp.toString().replace(/\D/g, '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1\."))
//       } else {
//         return temp
//           .toString()
//           .replace(/\D/g, '')
//           .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
//       }
//     }
//   }
//   if (str < 0) {
//     return (
//       '-' +
//       str
//         .toString()
//         .replace(/\D/g, '')
//         .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
//     );
//   } else {
//     return str
//       .toString()
//       .replace(/\D/g, '')
//       .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
//   }
// };

export const isValidEmail = (str: string) => {
  if (!str) return false;
  let emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  let result = emailRegex.test(str);
  if (result == true) {
    if (str[str.indexOf('@') + 1] == '-' || str[str.length - 1] == '-') {
      return false;
    }
  }
  return result;
};

export const isValidPhoneNumer = (str) => {
  if (!str) return false;
  if (str.length != 10) return false;
  if (str[0] != 0) return false;
  let phoneRegexStr = '^\\d{10}$';
  let phoneRegex = new RegExp(phoneRegexStr);
  return phoneRegex.test(str);
};

export const isValidReferralCode = (str) => {
  if (!str) return false;
  if (str.length > 50) return false;
  let referralRegex = new RegExp('^\\d+$');
  return referralRegex.test(str);
};

export const censorPhoneNumber = (phone: string) => {
  let splitArr = phone.split('');
  splitArr.splice(3, 3, 'x', 'x', 'x');
  return splitArr.join('');
};

export const censorGTTT = (gttt: string) => {
  let splitArr = gttt.split('');
  splitArr.splice(3, 2, 'x', 'x');
  return splitArr.join('');
};

export const getReplaceText = (
  text: string,
  replaceValue,
  replaceIdentifier?: string
): string => {
  return text.replace(replaceIdentifier || REPLACE_IDENTIFIER, replaceValue);
};

export const getReplaceTextMulti = (
  text: string,
  replaceValue: string[],
  replaceIdentifier: string = REPLACE_IDENTIFIER
): string => {
  const splitTextArr = text.split(replaceIdentifier);
  console.log('Split arr', splitTextArr);
  let newText = '';
  for (let i = 0; i < splitTextArr.length; i++) {
    newText += splitTextArr[i];
    if (i < splitTextArr.length - 1) {
      newText += replaceValue[i];
    }
  }
  return newText;
};

export function randomNumber(min, max) {
  const int = window.crypto.getRandomValues(new Uint32Array(1))[0];
  const value = int / 2 ** 32;
  return Math.floor(value * (max - min + 1) + min);
}

export function removeLeadingZeros(value) {
  return value?.replace(/^0+/, '');
}

export function generateUrlPayment(params) {
  let url = '/policy/payment';
  if (params.policyNum) {
    url += `?policyNum=${removeLeadingZeros(params.policyNum)}`;
  }
  if (params.paymentType) {
    url += `&paymentType=${params.paymentType}`;
  }
  if (params.bgIndex) {
    url += `&bgIndex=${params.bgIndex}`;
  }
  if (params.showDetail) {
    url += `&showDetail=true`;
  }
  return url;
}

export function validateTopUpFee(value, min, max) {
  value = value ?? 0;
  if (!Number.isInteger(value / 100000)) {
    return false;
  }
  if (value < min || value > max) {
    return false;
  }
  return true;
}

export const confirmQuit = (history, icon) => {
  PopupService.instance.current.open({
    visible: true,
    content: i18n.t('confirm_quit'),
    title: i18n.t('notification'),
    okTitle: i18n.t('no'),
    cancelTitle: i18n.t('yes'),
    onOk: () => {
      PopupService.instance.current.close();
    },
    onCancel: () => {
      PopupService.instance.current.close();
      history.push('/');
    },
    icon,
  });
};

export const showError = (content) => {
  PopupService.instance.current.open({
    visible: true,
    title: i18n.t('notification'),
    content: content ?? i18n.t('general_error'),
    okTitle: i18n.t('close'),
    onOk: () => {
      PopupService.instance.current.close();
    },
    showIcon: false,
  });
};

export const showContact = (content, hotline = 'hotline') => {
  PopupService.instance.current.open({
    visible: true,
    title: i18n.t('notification'),
    content: i18n.t(content),
    cancelTitle: i18n.t('later'),
    showContactButton: true,
    hotline: i18n.t(hotline),
    onOk: () => {
      PopupService.instance.current.close();
    },
    onCancel: () => {
      PopupService.instance.current.close();
    },
  });
};

export const paymentCheckDot = (value) => {
  return /\.$/.test(value);
};

export const featureInDevelopment = () => {
  PopupService.instance.current.open({
    visible: true,
    title: i18n.t('notification'),
    content: i18n.t('feature_in_development'),
    okTitle: i18n.t('close'),
    onOk: () => {
      PopupService.instance.current.close();
    },
    showIcon: false,
  });
};

export const isEmpty = (obj) => {
  return Object.keys(obj).length === 0;
};

export const preventInputNonNumber = function (event) {
  let value = event.target.value;
  event.target.value = value.replace(/[^0-9]/g, '');
};

export const  getDeviceOs = () => {
  let UNKNOWN = '?',
    FUNC_TYPE = 'function',
    OBJ_TYPE = 'object',
    STR_TYPE = 'string',
    NAME = 'name',
    VERSION = 'version';
  let BLACKBERRY = 'BlackBerry',
    CHROME = 'Chrome',
    FIREFOX = 'Firefox';
  let windowsVersionMap = {
    ME: '4.90',
    'NT 3.11': 'NT3.51',
    'NT 4.0': 'NT4.0',
    '2000': 'NT 5.0',
    XP: ['NT 5.1', 'NT 5.2'],
    Vista: 'NT 6.0',
    '7': 'NT 6.1',
    '8': 'NT 6.2',
    '8.1': 'NT 6.3',
    '10': ['NT 6.4', 'NT 10.0'],
    RT: 'ARM',
  };
  let has = function (str1, str2) {
      return typeof str1 === STR_TYPE
        ? lowerize(str2).indexOf(lowerize(str1)) !== -1
        : false;
    },
    lowerize = function (str) {
      return str.toLowerCase();
    };
  const strMapper = function (str, map) {
    for (let i in map) {
      // check if current value is array
      if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
        for (let j = 0; j < map[i].length; j++) {
          if (has(map[i][j], str)) {
            return i === UNKNOWN ? undefined : i;
          }
        }
      } else if (has(map[i], str)) {
        return i === UNKNOWN ? undefined : i;
      }
    }
    return str;
  };

  const osRegexMapper = [
    [
      // Windows
      /microsoft (windows) (vista|xp)/i, // Windows (iTunes)
    ],
    [NAME, VERSION],
    [
      /(windows) nt 6\.2; (arm)/i, // Windows RT
      /(windows (?:phone(?: os)?|mobile))[/ ]?([\d.\w ]*)/i, // Windows Phone
      /(windows)[/ ]?([ntce\d. ]+\w)(?!.+xbox)/i,
    ],
    [NAME, [VERSION, strMapper, windowsVersionMap]],
    [/(win(?=3|9|n)|win 9x )([nt\d.]+)/i],
    [
      [NAME, 'Windows'],
      [VERSION, strMapper, windowsVersionMap],
    ],
    [
      // iOS/macOS
      /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, // iOS
      /cfnetwork\/.+darwin/i,
    ],
    [
      [VERSION, /_/g, '.'],
      [NAME, 'iOS'],
    ],
    [
      /(mac os x) ?([\w. ]*)/i,
      /(macintosh|mac_powerpc\b)(?!.+haiku)/i, // Mac OS
    ],
    [
      [NAME, 'Mac OS'],
      [VERSION, /_/g, '.'],
    ],
    [
      // Mobile OSes
      /droid ([\w.]+)\b.+(android[- ]x86)/i, // Android-x86
    ],
    [VERSION, NAME],
    [
      // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
      /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-/ ]?([\w.]*)/i,
      /(blackberry)\w*\/([\w.]*)/i, // Blackberry
      /(tizen|kaios)[/ ]([\w.]+)/i, // Tizen/KaiOS
      /\((series40);/i, // Series 40
    ],
    [NAME, VERSION],
    [
      /\(bb(10);/i, // BlackBerry 10
    ],
    [VERSION, [NAME, BLACKBERRY]],
    [
      /(?:symbian ?os|symbos|s60(?=;)|series60)[-/ ]?([\w.]*)/i, // Symbian
    ],
    [VERSION, [NAME, 'Symbian']],
    [
      /mozilla\/[\d.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w.]+)/i, // Firefox OS
    ],
    [VERSION, [NAME, FIREFOX + ' OS']],
    [
      /web0s;.+rt(tv)/i,
      /\b(?:hp)?wos(?:browser)?\/([\w.]+)/i, // WebOS
    ],
    [VERSION, [NAME, 'webOS']],
    [
      // Google Chromecast
      /crkey\/([\d.]+)/i, // Google Chromecast
    ],
    [VERSION, [NAME, CHROME + 'cast']],
    [
      /(cros) [\w]+ ([\w.]+\w)/i, // Chromium OS
    ],
    [[NAME, 'Chromium OS'], VERSION],
    [
      // Console
      /(nintendo|playstation) ([wids345portablevuch]+)/i, // Nintendo/Playstation
      /(xbox); +xbox ([^);]+)/i, // Microsoft Xbox (360, One, X, S, Series X, Series S)

      // Other
      /\b(joli|palm)\b ?(?:os)?\/?([\w.]*)/i, // Joli/Palm
      /(mint)[/() ]?(\w*)/i, // Mint
      /(mageia|vectorlinux)[; ]/i, // Mageia/VectorLinux
      /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-/ ]?(?!chrom|package)([-\w.]*)/i,
      // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
      /(hurd|linux) ?([\w.]*)/i, // Hurd/Linux
      /(gnu) ?([\w.]*)/i, // GNU
      /\b([-frentopcghs]{0,5}bsd|dragonfly)[/ ]?(?!amd|[ix346]{1,2}86)([\w.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
      /(haiku) (\w+)/i, // Haiku
    ],
    [NAME, VERSION],
    [
      /(sunos) ?([\w.\d]*)/i, // Solaris
    ],
    [[NAME, 'Solaris'], VERSION],
    [
      /((?:open)?solaris)[-/ ]?([\w.]*)/i, // Solaris
      /(aix) ((\d)(?=\.|\)| )[\w.])*/i, // AIX
      /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i, // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
      /(unix) ?([\w.]*)/i, // UNIX
    ],
    [NAME, VERSION],
  ];
  const rgxMapper = function (ua, arrays) {
    let i = 0,
      j,
      k,
      p,
      q,
      matches,
      match;

    // loop through all regexes maps
    while (i < arrays.length && !matches) {
      let regex = arrays[i], // even sequence (0,2,4,..)
        props = arrays[i + 1]; // odd sequence (1,3,5,..)
      j = k = 0;

      // try matching uastring with regexes
      while (j < regex.length && !matches) {
        matches = regex[j++].exec(ua);

        if (matches) {
          for (p = 0; p < props.length; p++) {
            match = matches[++k];
            q = props[p];
            // check if given property is actually array
            if (typeof q === OBJ_TYPE && q.length > 0) {
              if (q.length === 2) {
                if (typeof q[1] == FUNC_TYPE) {
                  // assign modified match
                  this[q[0]] = q[1].call(this, match);
                } else {
                  // assign given value, ignore regex match
                  this[q[0]] = q[1];
                }
              } else if (q.length === 3) {
                // check whether function or regex
                if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                  // call function (usually string mapper)
                  this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                } else {
                  // sanitize match using given regex
                  this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                }
              } else if (q.length === 4) {
                this[q[0]] = match
                  ? q[3].call(this, match.replace(q[1], q[2]))
                  : undefined;
              }
            } else {
              this[q] = match ? match : undefined;
            }
          }
        }
      }
      i += 2;
    }
  };
  let _os = {
    name: undefined,
    version: undefined,
  };
  let _ua =
    typeof window !== 'undefined' &&
    window.navigator &&
    window.navigator.userAgent
      ? window.navigator.userAgent
      : '';
  rgxMapper.call(_os, _ua, osRegexMapper);
  return _os;
}

export const gaTrackingAndLogAction = async ({
  pub,
  event,
  actionType,
  eventDirectory,
}) => {
  const userInfo = UserInfoService.getUserInfo();
  await gaTrackEvent(pub, event.name, userInfo?.idCardNo ?? "");
  const deviceOs = getDeviceOs();
  let deviceOsStr = '';
  const osName = deviceOs?.name;
  if(osName){
    deviceOsStr = osName;
    const osVersion = deviceOs?.version;
    if(osVersion){
      deviceOsStr += ' ' + osVersion;
    }
  }
  await wakandaLogActionApi({
    actionType: actionType,
    eventDirectory: eventDirectory,
    logId: event.code,
    logName: event.name,
    deviceOs: deviceOsStr ? deviceOsStr : null,
    idCardNo: userInfo?.idCardNo ?? "",
    cif: userInfo?.cif ?? "",
  });
  return true;
}

export const getLoginToken = () => {
  let loginToken = '';
  try {
    loginToken = window.location.href.split('loginToken=')[1]?.split('&')[0]||''
  } catch (e) {
    console.error(e);
  }
  return loginToken
}

export const formatDate = (date: string, formatString = 'DD-MM-YYYY', returnFormat = "DD/MM/YYYY") => {
  let dateMoment = moment(date, formatString)
  if(dateMoment.isValid()){
    return dateMoment.format(returnFormat)
  }
  return null
}
